import React from "react";
import { FormattedMessage } from "react-intl";

import { DeviceNameCell } from "../../../../components/table";
import { DeviceWithType } from "../../../../components/devices/DeviceWithType";
import {
  multipleThreatsSort,
  singleDeviceIdSort,
} from "../../../../components/table/helpers/sorting.helper";
import { InfectionsList } from "../../../../components/infectionsList/InfectionsList";
import { InfectedDevicesActionsDropdown, TableCard } from "./components";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    Cell: ({
      row: {
        original: { name },
      },
    }) => <DeviceNameCell name={name} />,
  },
  {
    Header: <FormattedMessage id={"device_id_devices_table_header"} />,
    accessor: "id",
    Cell: ({
      row: {
        original: { type, id },
      },
    }) => {
      return <DeviceWithType type={type} identifier={id} />;
    },
    sortType: singleDeviceIdSort,
  },
  {
    Header: <FormattedMessage id={"infections_devices_table_header"} />,
    sortType: multipleThreatsSort,
    accessor: "flatInfections",
    Cell: ({
      row: {
        original: { infections },
      },
    }) => <InfectionsList infections={infections} />,
  },
  {
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    Header: <FormattedMessage id={"actions"} />,
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { type, id, manufacturer, name },
      },
    }) => (
      <InfectedDevicesActionsDropdown
        device={{ type, manufacturer, name, identifiers: [id] }}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: { type, manufacturer, name, id, infections },
      },
    }) => (
      <TableCard
        isExpanded={isExpanded}
        type={type}
        manufacturer={manufacturer}
        name={name}
        id={id}
        infections={infections}
      />
    ),
    sortType: singleDeviceIdSort,
  },
  {
    accessor: "id",
    SortingLabel: <FormattedMessage id={"device_id_devices_table_header"} />,
  },
  {
    accessor: "flatInfections",
    sortType: multipleThreatsSort,
    SortingLabel: <FormattedMessage id={"infections_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = ["flatInfections", "name", "id"];

export const INITIAL_SORT = [{ id: "flatInfections", desc: true }];

export const SUB_HEADER = (
  <FormattedMessage id={"showing_data_for_the_past_24"} />
);
